import React from "react";

import {
    surveySessionColumnItem,
    colEmail,
    colOccasion,
    colCreatedDate,
    colStatus,
} from "./survey-session-column-item.module.scss";

type SurveySessionListColumnName = "email" | "occasion" | "created-date" | "status";

const COLUMN_CLASS: Record<SurveySessionListColumnName, string> = {
    email: colEmail,
    occasion: colOccasion,
    "created-date": colCreatedDate,
    status: colStatus,
};

export type SurveySessionColumnItemProps<ComponentType extends React.ElementType> = {
    Component?: ComponentType;
    columnName: SurveySessionListColumnName;
    mobileLabel?: string;
};

export default function SurveySessionColumnItem<ComponentType extends React.ElementType = "p">({
    Component = "p",
    columnName,
    mobileLabel,
    ...props
}: SurveySessionColumnItemProps<ComponentType> & React.ComponentProps<ComponentType>) {
    return (
        <div
            className={`${surveySessionColumnItem} ${COLUMN_CLASS[columnName]}`}
            data-survey-list-cell
            data-mobile-label={mobileLabel || undefined}
        >
            <Component {...props} />
        </div>
    );
}
